export const tempGrades_en = ['Platinum', 'Black', 'Gold', 'Silver', 'Bronze'];

export const tempGrades_ko = ['플래티넘', '블랙', '골드', '실버', '브론즈'];

export const tempDumans_en = ['Tori', 'Collin', 'Dove', 'KM', 'Andre'];

export const tempDumans_ko = ['푸들', '보더콜리', '도베르만', '진도', '불독'];

export const tempMystery_en = ['Mystery Box'];

export const tempMystery_ko = ['Mystery Box'];

export const tempCards_en = ['SHILLA Platinum NFT CARD'];

export const tempCards_ko = ['신라 플래티넘 NFT CARD'];

export const tempMembership = [
	'PARK HYATT MEMBERSHIP CARD',
	'LOTTE HOTEL MEMBERSHIP CARD',
	'TS TRILLION MEMBERSHIP CARD',
	'MAMMOTH MEMBERSHIP CARD',
	'VLUV MEMBERSHIP CARD',
];

export const tempCurrencyList = [
	'($) United States Dollar (USD)',
	'(₩) South Korean won (KRW)',
];

export const tempNftMarketSortList = [
	'Price : Low to High',
	'Price : High to Low',
];

export const tempNftMarketCategoryList = [
	'duman',
	'konnect card',
	'mystery box',
	'partners utility NFT',
];

//language json으로 옮겨야 함
export const nftMarketCategoryHeaderData = {
	duman: {
		title: 'DUMAN',
		description: ` DUMAN is one of species of Konnect world.\n
        DUMAN's PFP NFT provides additional benefits on top of Konnect membership.`,
		benefit: [
			'Additional discounts for Konnect membership',
			"Discounts on purchase of Konnect World's NFTs.",
		],
	},
	'konnect card': {
		title: 'Konnect Card',
		description: ` Mystery Box contains a Konnect Goods Card. You can receive more than 
        the purchased amount at random, and additional benefits are given.`,
		benefit: [
			'Offer physical goods shown on the card',
			'Additional discount rate for Konnect membership',
		],
	},
	'mystery box': {
		title: 'MYSTERY BOX',
		description: ` Mystery Box contains a Konnect Goods Card. You can receive more than 
        the purchased amount at random, and additional benefits are given.`,
		benefit: [
			'Offer physical goods shown on the card',
			'Additional discount rate for Konnect membership',
		],
	},
	'partners utility NFT': {
		title: 'Partners Utility NFT',
		description: '',
		benefit: '',
	},
};

export const tempGallerySortList_en = [
	'NFT Number : Low to High',
	'NFT Number : High to Low',
];

export const tempGallerySortList_ko = [
	'NFT 번호 : 오름차순',
	'NFT 번호 : 내림차순',
];

export const tempGalleryCategoryList_en = {
	DUMAN: [...tempDumans_en],
	'Mystery Box': [...tempMystery_en],
	'Konnect Product Card': [...tempGrades_en],
	'Partners Utility Card': [...tempCards_en],
	'Konnect Membership': [...tempMembership],
};

export const tempGalleryCategoryList_ko = {
	DUMAN: [...tempDumans_ko],
	'Mystery Box': [...tempMystery_ko],
	'Konnect Product Card': [...tempGrades_ko],
	'Partners Utility Card': [...tempCards_ko],
	'Konnect Membership': [...tempMembership],
};

export const tempGalleryCategoryHeaderData_en = {
	Benefits: { title: 'Real benefits' },
	DUMAN: {
		title: 'DUMAN',
		description: `DUMAN is one of species of Konnect world.\nDUMAN's PFP NFT provides additional benefits on top of Konnect membership.
        `,
		benefit: [
			'Additional discounts for Konnect membership',
			"Discounts on purchase of Konnect World's NFTs.",
		],
	},
	'Konnect Product Card': {
		title: 'Konnect Product Card',
		description: `Mystery Box contains a Konnect Goods Card. You can receive more than the purchased amount at random, and additional benefits are given.`,
		benefit: [
			'Offer physical goods shown on the card',
			'Additional discount rate for Konnect membership',
		],
	},
	'Partners Utility Card': {
		title: 'Partners Utility Card',
		description: 'Partners Utility Card',
		benefit: ['Dynamic perks and benefits'],
	},
	'Mystery Box': {
		title: 'MYSTERY BOX',
		description:
			'This is a product that you can get a goods card that can be exchanged in real life with a random probability.',
		benefit: [''],
	},
	'partners utility NFT': {
		title: 'Partners Utility NFT',
		description: '',
		benefit: [''],
	},
	'Konnect Membership': {
		title: 'Konnect Membership',
		description: '',
		benefit: [''],
	},
};

export const tempGalleryCategoryHeaderData_ko = {
	Benefits: { title: '현실 헤택' },
	DUMAN: {
		title: 'DUMAN',
		description: `DUMAN은 Konnect World에 살고 있는 종족 중 하나입니다.\nDUMAN PFP NFT는 Konnect 멤버십과 더불어 부가 혜택을 제공합니다.`,
		benefit: ['Konnect 멤버십 추가 할인', 'Konnect World NFT 구매 할인'],
	},
	'Konnect Product Card': {
		title: 'Konnect Product Card',
		description: `미스터리 박스에서 무작위로 실제 상품으로 교환할 수 있는 Konnect Product Card를 획득할 수 있습니다.`,
		benefit: ['카드에 나와있는 실제 상품 교환'],
	},
	'Partners Utility Card': {
		title: 'Partners Utility Card',
		description: '파트너 유틸리티 카드',
		benefit: ['동적 특전 및 혜택'],
	},
	'Mystery Box': {
		title: 'MYSTERY BOX',
		description:
			'실물교환이 가능한 굿즈 카드를 랜덤확률로 얻을 수 있는 상품입니다.',
		benefit: [''],
	},
	'Konnect Membership': {
		title: 'Konnect Membership',
		description: '',
		benefit: [''],
	},
};

export const tempGalleryDumans = [
	{
		id: '1',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle1.png',
	},
	{
		id: '2',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle2.png',
	},
	{
		id: '3',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle3.png',
	},
	{
		id: '4',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle1.png',
	},
	{
		id: '5',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle2.png',
	},
	{
		id: '6',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle3.png',
	},
	{
		id: '7',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle1.png',
	},
	{
		id: '8',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle2.png',
	},
	{
		id: '9',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle3.png',
	},
	{
		id: '10',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle1.png',
	},
	{
		id: '11',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle2.png',
	},
	{
		id: '12',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle3.png',
	},
	{
		id: '13',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle1.png',
	},
	{
		id: '14',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle2.png',
	},
];

export const tempGalleryCards = [
	{
		id: '1',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card1.png',
	},
	{
		id: '2',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card2.png',
	},
	// {
	//     id: "3",
	//     category: "Konnect Product Card",
	//     subCategory: {en: tempGrades_en[0], ko: tempGrades_ko[0]},
	//     name: "",
	//     img: "card3.png"
	// },
	{
		id: '4',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[2], ko: tempGrades_ko[2] },
		name: '',
		img: 'card4.png',
	},
	{
		id: '5',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[3], ko: tempGrades_ko[3] },
		name: '',
		img: 'card5.png',
	},
	// {
	//     id: "6",
	//     category: "Konnect Product Card",
	//     subCategory: {en: tempGrades_en[0], ko: tempGrades_ko[0]},
	//     name: "",
	//     img: "card6.png"
	// },
	{
		id: '7',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card1.png',
	},
	{
		id: '8',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card2.png',
	},
	// {
	//     id: "9",
	//     category: "Konnect Product Card",
	//     subCategory: {en: tempGrades_en[0], ko: tempGrades_ko[0]},
	//     name: "",
	//     img: "card3.png"
	// },
	{
		id: '10',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[2], ko: tempGrades_ko[2] },
		name: '',
		img: 'card4.png',
	},
	{
		id: '11',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[3], ko: tempGrades_ko[3] },
		name: '',
		img: 'card5.png',
	},
	// {
	//     id: "12",
	//     category: "Konnect Product Card",
	//     subCategory: {en: tempGrades_en[0], ko: tempGrades_ko[0]},
	//     name: "",
	//     img: "card6.png"
	// },
	{
		id: '13',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card1.png',
	},
];

export const tempMyPagePFPs = [
	{
		id: '1',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle1.png',
	},
	{
		id: '2',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle2.png',
	},
	{
		id: '3',
		category: 'DUMAN',
		subCategory: { en: tempDumans_en[0], ko: tempDumans_ko[0] },
		name: 'TORI',
		img: 'poodle3.png',
	},
	{
		id: '4',
		category: 'Konnect Goods Card',
		subCategory: { en: tempGrades_en[2], ko: tempGrades_ko[2] },
		name: '',
		img: 'card4.png',
	},
	{
		id: '5',
		category: 'Konnect Goods Card',
		subCategory: { en: tempGrades_en[3], ko: tempGrades_ko[3] },
		name: '',
		img: 'card5.png',
	},
];

export const tempMyPageProductCards = [
	{
		id: '1',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card1.png',
	},
	{
		id: '2',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card2.png',
	},
	{
		id: '4',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[2], ko: tempGrades_ko[2] },
		name: '',
		img: 'card4.png',
	},
	{
		id: '5',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[3], ko: tempGrades_ko[3] },
		name: '',
		img: 'card5.png',
	},
	{
		id: '7',
		category: 'Konnect Product Card',
		subCategory: { en: tempGrades_en[0], ko: tempGrades_ko[0] },
		name: '',
		img: 'card1.png',
	},
];

export const tempOnChainCollectionCategoryList_en = {
	'Konnect Mystery': ['All'],
	'Konnect NFT Package': ['All'],
	'Konnect Product Card': ['All'],
	'Konnect PFP NFT': ['All', 'DUMAN'],
	'Konnect Wearable Card': ['All', 'DUMAN'],
	'Konnect Membership Card': ['All'],
	'Partners Utility Card': ['All'],
};

export const tempOnChainCollectionCategoryList_ko = {
	'Konnect Mystery': ['All'],
	'Konnect NFT Package': ['All'],
	'Konnect Product Card': ['All'],
	'Konnect PFP NFT': ['All', 'DUMAN'],
	'Konnect Wearable Card': ['All', 'DUMAN'],
	'Konnect Membership Card': ['All'],
	'Partners Utility Card': ['All'],
};

export const tempOffChainCollectionItems = [
	// {
	//     id: "1",
	//     category: "DUMAN",
	//     subCategory: {en: tempDumans_en[0], ko: tempDumans_ko[0]},
	//     name: "TORI",
	//     img: "poodle1.png"
	// },
	// {
	//     id: "2",
	//     category: "DUMAN",
	//     subCategory: {en: tempDumans_en[0], ko: tempDumans_ko[0]},
	//     name: "TORI",
	//     img: "poodle2.png"
	// },
	// {
	//     id: "3",
	//     category: "DUMAN",
	//     subCategory: {en: tempDumans_en[0], ko: tempDumans_ko[0]},
	//     name: "TORI",
	//     img: "poodle3.png"
	// },
	// {
	//     id: "4",
	//     category: "DUMAN",
	//     subCategory: {en: tempDumans_en[0], ko: tempDumans_ko[0]},
	//     name: "TORI",
	//     img: "poodle1.png"
	// },
	// {
	//     id: "5",
	//     category: "DUMAN",
	//     subCategory: {en: tempDumans_en[0], ko: tempDumans_ko[0]},
	//     name: "TORI",
	//     img: "poodle2.png"
	// },
	// {
	//     id: "6",
	//     category: "DUMAN",
	//     subCategory: {en: tempDumans_en[0], ko: tempDumans_ko[0]},
	//     name: "TORI",
	//     img: "poodle3.png"
	// },
	// {
	//     id: "7",
	//     category: "DUMAN",
	//     subCategory: {en: tempDumans_en[0], ko: tempDumans_ko[0]},
	//     name: "TORI",
	//     img: "poodle1.png"
	// },
];
